import component from './unsupported.component';
import service from './unsupported.service';

export default angular.module('mpdx.unsupported', [component, service]).name;
